var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('audio',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:'audio'+_vm.info.id,attrs:{"controls":"","src":_vm.info.url},on:{"canplay":_vm.getDuration}})])
}
var staticRenderFns = []

export { render, staticRenderFns }